import { render, staticRenderFns } from "./zhandian.vue?vue&type=template&id=49b81a44&scoped=true"
import script from "./zhandian.vue?vue&type=script&lang=js"
export * from "./zhandian.vue?vue&type=script&lang=js"
import style0 from "./zhandian.vue?vue&type=style&index=0&id=49b81a44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b81a44",
  null
  
)

export default component.exports